export default "__VITE_ASSET__DAfG0$0O__"